export default __webpack_public_path__ + "static/media/1-2-downloadingStateData.86710ac4.png";